var rich_content_viewer_default = {
  "fontElementMap": "gscJ-",
  "wrapper": "xHm6Z",
  "pluginContainerMobile": "_6PUe8",
  "viewer": "_0pzoS",
  "android": "_4CvLL",
  "rootedTraversedContent": "Yt9Md",
  "atomic": "O0UP6",
  "toolbar": "vcP-a",
  "block": "cpcEY"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
